import { api } from "@/lib/api";
export const updateProfile = (data: any) => api.post("/resident/update-profile", data);
export const updatePassword = (data: any) => api.post("/accounts/update-password", data);